import React from 'react';
import SelectField from '../../common/SelectField.js';

export const DEFAULT_DATE_RANGE = 'this_month';

const DATE_RANGE_OPTIONS = [
  { value: 'all_time', label: 'All Time' },
  { value: 'this_month', label: 'This Month' },
  { value: 'last_3_months', label: 'Last 3 Months' },
  { value: 'last_6_months', label: 'Last 6 Months' },
  { value: 'last_year', label: 'Last Year' },
  { value: 'custom', label: 'Custom' },
];

const DateRangeFilter = ({
  value = DEFAULT_DATE_RANGE,
  onChange,
  customStart = '',
  customEnd = '',
  onCustomStartChange,
  onCustomEndChange,
  className = '',
  wide = false,
}) => {
  const handleSelect = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={`flex flex-wrap items-center gap-1.5 sm:gap-3 min-w-0 w-full md:w-auto ${className}`}>
      <SelectField
        variant="filter"
        value={value}
        onChange={handleSelect}
        options={DATE_RANGE_OPTIONS}
        className={`w-full min-w-0 md:w-auto md:max-w-none ${wide ? 'md:min-w-[280px]' : 'md:min-w-[140px]'}`}
      />

      {value === 'custom' && (
        <>
          <div>
            <label className="block text-sm font-medium text-dark mb-1">Start Date</label>
            <input
              type="date"
              value={customStart}
              onChange={(e) => onCustomStartChange(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-dark mb-1">End Date</label>
            <input
              type="date"
              value={customEnd}
              onChange={(e) => onCustomEndChange(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </>
      )}
    </div>
  );
};

export function buildDateParams(dateRange, customStart, customEnd) {
  const params = {};
  if (dateRange && dateRange !== 'all_time') {
    params.date_range = dateRange;
    if (dateRange === 'custom') {
      if (customStart) params.from_date = customStart;
      if (customEnd) params.to_date = customEnd;
    }
  }
  return params;
}

export default DateRangeFilter;
